module.exports = __webpack_public_path__ + "img/add-img.5883cede.svg";